import React from 'react'

const Content = (props) => {
     if(props.isColor==="black"){
  return (
  <div>
        <div className=" p-2 font-bold text-black text-2xl">{props.title}</div>
        <div className=" p-2 font-semibold text-black text-3xl">{props.subtitle} </div>
        <div className=" p-2 text-black text-sm">{props.content}</div>
    </div>
  )}
  else if(props.isColor==="chrome"){
  return (
  <div>
        <div className=" p-2 font-bold text-[#d2a960] text-2xl">_ {props.title} _</div>
        <div className=" p-2 font-semibold text-white text-4xl">{props.subtitle} </div>
        <div className=" p-2 text-white text-sm">{props.content}</div>
    </div>
  )}

  else if(props.isColor){
  return (
  <div>
        <div className=" p-2 md:mt-7 font-bold text-[#d2a960] text-2xl">_ {props.title} _</div>
        <div className=" p-2 text-black font-semibold text-4xl">{props.subtitle} </div>
        <div className=" p-2 text-black text-xl">{props.content}</div>
    </div>
  )}
 
  
  else{
  return (
    <div className="container mx-auto flex flex-col ">
        <div className=" p-2 md:mt-7 font-bold text-white text-2xl">_ {props.title} _</div>
        <div className=" p-2 text-white font-semibold text-4xl">{props.subtitle} </div>
        <div className=" p-2 text-white text-lg">{props.content}</div>
    </div>
  )}
}

export default Content